import { formatTimeAgo } from "../formatTimeAgo";
import { AlertData, AlertLevelData, AlertsTimelineData, RiskyAlertData, RiskyMachineData, RiskyUserData } from "../interfaces/CommonInterfaces";

export const transformAlertsResponse = (response: any[]): AlertData[] => {
  return response.map((item) => {
    let sigmaResults: any[] = [];
    try {
      sigmaResults = JSON.parse(item.sigma_results || "[]");
    } catch {
      sigmaResults = [];
    }

    let timeAgo = item.timestamp
      ? formatTimeAgo(item.timestamp)
      : item._time
        ? formatTimeAgo(item._time)
        : ""




    return {
      id: `${item._time}-${item.Computer || "unknown"}`,
      level: sigmaResults?.[0]?.Level || "low",
      user: item.ProcessUser || item.user || "",
      computerId:
        item.computerId ||
        item.computerID ||
        item.ComputerId ||
        item.computer_id ||
        "",
      computerName: item.Computer || "",
      processName: item.Process || "",
      message: sigmaResults?.[0]?.Title || item.message || "",
      type: item._measurement || "",
      updatedAt: timeAgo,

      tags: sigmaResults?.[0]?.Tags || [],
      sigmaResults: sigmaResults || [],
      computerUserEmail: item.computerUserEmail || "",
      resourceName: item.resourceName || "",
      time: item.Time || "",
      Process: item.Process || "",
      eventjson: item.eventJson,
    } as AlertData;



  });
};


export const getAlertLevels = (alerts: AlertData[]): AlertLevelData[] => {
  const colors: Record<string, string> = {
    critical: "#ff0000",
    high: "#ff5733",
    medium: "#ffc107",
    low: "#28a745",
  };

  const levelCounts: Record<string, number> = {};

  alerts.forEach((alert) => {
    levelCounts[alert.level] = (levelCounts[alert.level] || 0) + 1;
  });

  return Object.entries(levelCounts).map(([level, count]) => ({
    level,
    count,
    color: colors[level] || "#6c757d", // fallback gray
  }));
};


export const getAlertsTimeline = (alerts: AlertData[]): AlertsTimelineData[] => {
  const timeline: Record<string, number> = {};

  alerts.forEach((alert) => {
    const date = alert.updatedAt.split("T")[0]; // "2025-09-20"
    timeline[date] = (timeline[date] || 0) + 1;
  });

  return Object.entries(timeline).map(([date, alerts]) => ({
    date,
    alerts,
  }));
};

export const getRiskyAlerts = (alerts: AlertData[]): RiskyAlertData[] => {
  const total = alerts.length;
  const riskyMap: Record<string, { count: number; level: string; tags?: string[] }> = {};

  alerts.forEach((alert) => {
    if (!riskyMap[alert.message]) {
      riskyMap[alert.message] = { count: 0, level: alert.level, tags: alert.tags };
    }
    riskyMap[alert.message].count += 1;
  });

  return Object.entries(riskyMap).map(([name, data], idx) => ({
    id: `alert-${idx}`,
    name,
    description: `Alert of type: ${name}`,
    level: data.level,
    count: data.count,
    percentage: ((data.count / total) * 100).toFixed(1) + "%",
  }));
};


export const getRiskyUsers = (alerts: AlertData[]): RiskyUserData[] => {
  const total = alerts.length;
  const userMap: Record<string, number> = {};

  alerts.forEach((alert) => {
    if (!alert.user) return;
    userMap[alert.user] = (userMap[alert.user] || 0) + 1;
  });

  return Object.entries(userMap).map(([username, count], idx) => ({
    id: `user-${idx}`,
    username,
    alertCount: count,
    percentage: ((count / total) * 100).toFixed(1) + "%",
  }));
};


export const getRiskyMachines = (alerts: AlertData[]): RiskyMachineData[] => {
  const total = alerts.length;
  const machineMap: Record<string, number> = {};

  alerts.forEach((alert) => {
    if (!alert.computerName) return;
    machineMap[alert.computerName] = (machineMap[alert.computerName] || 0) + 1;
  });

  return Object.entries(machineMap).map(([computerName, count], idx) => ({
    id: `machine-${idx}`,
    computerName,
    alertCount: count,
    percentage: ((count / total) * 100).toFixed(1) + "%",
  }));
};
